import { useTranslation } from 'react-i18next';

// Import specific components from external UI library
import {
  Button,
  Headings,
  ModalOverlay,
  Paragraph
} from '@sentara-health/optimahealth_web';

// Define the prop types for DeleteAccountPopup component
interface DeleteAccountPopupProps {
  isOpen: boolean; // Flag indicating if the modal is open
  closeModal: () => void; // Function to close the modal
  isShowContent: boolean; // Flag indicating if modal content should be shown
  variant: string; // Variant of the buttons
  deleteAccount: () => void; // Function to handle account deletion
  isConfirmOpen: boolean; // Flag indicating if the confirmation modal is open
  confirmDeleteAccount: () => void; // Function to confirm account deletion
}

// Define the DeleteAccountPopup component
function DeleteAccountPopup({
  isOpen,
  closeModal,
  isShowContent,
  variant,
  deleteAccount,
  isConfirmOpen,
  confirmDeleteAccount,
}: Readonly<DeleteAccountPopupProps>) {
  // Initialize translation hook
  const { t } = useTranslation();

  return (
      <div className="modal-wrapper" data-testid="modalWrapper">
        <ModalOverlay
          isOpen={isOpen}
          onClose={() => {
            closeModal();
          }}
          overlayInfo="Account delete overlay"
        >
          {/* Display content when isShowContent flag is true */}
          {isShowContent && (
            <div data-testid="accountDeleteModalTitle">
              <Headings
                level={4}
                text={t('profile.accountDeleteModalTitle')}
                variant="bold"
                className="mb-3 me-4"
              />
              {/* Description paragraphs */}
              <Paragraph text={t('profile.accountDeleteModalDescription')} variant="regular" data-testid="accountDeleteModalDescription" className="mb-4" />
              <Paragraph text={t('profile.accountDeleteModalDescription1')} variant="regular" data-testid="accountDeleteModalDescription1" className="mb-4" />
              <Paragraph text={t('profile.accountDeleteModalDescription2')} variant="regular" data-testid="accountDeleteModalDescription2" className="mb-4" />
              <Paragraph text={t('profile.accountDeleteModalDescription3')} variant="regular" data-testid="accountDeleteModalDescription3" className="mb-4" />
              <Paragraph text={t('profile.accountDeleteModalDescription4')} variant="regular" data-testid="accountDeleteModalDescription4" className="mb-4" />
            <div className="row d-flex justify-content-start align-items-center py-2">
              <div className="col-sm-auto col-12 mb-sm-0 mb-4">
                <Button
                  dataTestId={'continueButton'}
                  variant={variant}
                  type="submit"
                  onClick={confirmDeleteAccount}
                >{t('common.confirm')}
                </Button>
              </div>
              <div className="col-sm-auto col-12 mb-sm-0">
                <Button
                  dataTestId={'cancelButton'}
                  variant='secondary_btn'
                  onClick={() => {
                    closeModal()
                  }}
                >{t('common.cancel')}
                </Button>
              </div>
            </div>
          </div>
          )}
        </ModalOverlay>
      </div>
  );
}

export default DeleteAccountPopup;
